module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-door-horizontal-top-mask.3df01678.png";